import { SyntheticEvent, useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getBrand, createBrand } from "../../redux/brandSlice";
import { useDispatch, useSelector } from "react-redux";
import { Button, FormControl, FormControlLabel, IconButton, MenuItem, Radio, RadioGroup, TextField, ThemeProvider, createTheme } from "@mui/material";
import React from "react";
import { Brand } from "../../model/brand.model";
import { BrandsService } from "../../service/brands.service";
import { CategoryService } from "../../service/categories.service";
//import { isNumber } from "lodash";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { ToastContainer, toast } from "react-toastify";
import { Category } from "../../model/category.model";



function SubCategoryDetails() {
  const params = useParams();
  const brandId = params.brandid;
  const dispatch = useDispatch();
  const { brand } = useSelector((state: any) => state.brandSlice);
  const navigate = useNavigate();
  const [picture, setPicture] = useState(null);
  const [imgData, setImgData] = useState<string[]>([]);
  const [status, setStatus] = React.useState(1);
  const [brandName, setBrandName] = React.useState("");
  const [selectedBrandId, setSelectedBrandId] = React.useState("select");
  const [availableBrands, setAvailableBrands] = useState<Brand[]>([]);
  const brandsService = new BrandsService();
  const [catName, setcatName] = React.useState("");
  const [catImage, setcatImage] = React.useState("");
  const [catImageData, setcatImageData] = React.useState("");
  const categoryService = new CategoryService();

  const [selectedCategoryId, setSelectedCategoryId] = React.useState("select");
  const [availableCategories, setAvailableCategories] = useState<Category[]>([]);
  const [subCatId, subSubCatId] = React.useState("");
  const [errMsg, setErrMsg] = useState('');
  const [isedit, setIsEdit] = React.useState(true);

  const location = useLocation();


  const loadAllBrands = () => {

    brandsService.brands(1).then(data => {
      const res = data.data;
      setAvailableBrands(res);

    });
  }


  let parameters = {}
  let iscalled = false;
  useEffect(() => {
    //console.log("+++++++++++++++selectedBradId : " + selectedBrandId)
    if (!iscalled) {
      iscalled = true

      if (location != null && location.state != null && location.state.categoryDetails != null) {
        parameters = location.state.categoryDetails;

        console.log("params ", parameters)

        setcatName(location.state.categoryDetails.catName)
        setAvailableBrands(location.state.brandsData)
        setAvailableCategories(location.state.categoryData)
        setSelectedBrandId(location.state.categoryDetails.brandId)
        setcatImage(((location.state.categoryDetails.catImage).split("/").pop()))
        setStatus(location.state.categoryDetails.status)
        subSubCatId(location.state.categoryDetails.catId)
        setSelectedCategoryId(location.state.categoryDetails.parentId)
        setIsEdit(false)
      } else {
        loadAllBrands();
      }

    }
  }, []);

  const onChangePicture = (e: any) => {
    if (e.target.files[0]) {
      setPicture(e.target.files[0]);
      // setImgData(URL.createObjectURL(e.target.files[0]));
    }
  };

  const createNewSubCategory = () => {
    // 
    const data = {
      "catId": subCatId,
      "brandId": Number(selectedBrandId),
      "catParentId": Number(selectedCategoryId),
      "catName": catName,
      "status": status,
      "catImage": catImage,
      "catImageData": catImageData
    };
    categoryService.createSubCategory(data).then((res: any) => {
      /*toast.success('Product created successfully', {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      navigate('../sub_categories');
    }).catch((err: any) => {
      console.log('err ', err);
      setErrMsg('Something went wrong while creating the product');
    });*/
    if (res.status == '100') {

      toast.success("Updated Successfully !!!", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 2000,
        hideProgressBar: true,
      });
      setTimeout(() => {
        navigate('../sub_categories');
      }, 2100);

    } else {
      toast.error("No Data Available!!!", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 2000,
        hideProgressBar: true,
      });
      setTimeout(() => {
        navigate('../sub_categories');
      }, 2100);
    }
  })
};
  const onUploadDispImg = (event: SyntheticEvent) => {
    const element = event.target as HTMLInputElement;
    if (element.files) {

      const file = element.files[0];
      console.log("^^^CadtImg^^^^^^^^^^file : " + file.name);
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        setcatImage(file.name);
        setcatImageData(reader.result as string);
      }
      reader.onerror = (e) => { console.log('err') }
    }
  }

  const loadMainCategories = (brandID: number) => {
    console.log("~~~~~~~~~~~~~~~selectedBrandId:" + selectedBrandId + ",sCatId: " + brandID);
    setSelectedCategoryId("select")
    categoryService.categories(brandID).then(data => {
      const res = data.data;

      setAvailableCategories(res)
    }).catch(err => {
      setAvailableCategories([]);
    });




  }

  const handleStatus = (event: React.ChangeEvent<HTMLInputElement>, value: Number) => {
    setStatus(Number(value));
  }

  const CustomFontTheme = createTheme({
    typography: {
      fontSize: 14
    }
  });
  return (
    <div className="App border card">
      <div className="card-body ">
        <div className="mt-3 col-12 row  ">
          <div className="col-4 form-group  text-left">
            <ThemeProvider theme={CustomFontTheme}>
              <TextField select size="small" label="Brand Name" id="outlined-start-adornment" InputLabelProps={{ shrink: true }}
                className="form-control" name='brandId' defaultValue="select" value={selectedBrandId}
                disabled={!isedit}
                onChange={(e: any) => {
                  setSelectedBrandId(e.target.value);
                  loadMainCategories(Number(e.target.value));
                }}>
                <MenuItem disabled value="select" key="select">Select</MenuItem>
                {availableBrands.map((_el: any) => <MenuItem key={_el.brandId} value={_el.brandId}>{_el.brandName}</MenuItem>)}
              </TextField>
            </ThemeProvider>
          </div>
          <div className="col-4 form-group  text-left">
            <ThemeProvider theme={CustomFontTheme}>
              <TextField select size="small" label="Main Category" id="outlined-start-adornment" InputLabelProps={{ shrink: true }}
                className="form-control" name='brandId' defaultValue="select" value={selectedCategoryId}
                disabled={!isedit}
                onChange={(e: any) => {
                  setSelectedCategoryId(e.target.value);
                }}>
                <MenuItem disabled value="select" key="select">Select</MenuItem>
                {availableCategories.map((_el: any) => <MenuItem key={_el.catId} value={_el.catId}>{_el.catName}</MenuItem>)}
              </TextField>
            </ThemeProvider>
          </div>
          <div className="col-4 text-left">
            <ThemeProvider theme={CustomFontTheme}>
              <TextField size="small" label="Sub Category Name" id="outlined-start-adornment" InputLabelProps={{ shrink: true }}
                type="text" className="form-control" name='prodDispName' value={catName}
                onChange={(e: any) => {
                  setcatName(e.target.value);
                }} />
            </ThemeProvider>
          </div>
          <div className='col-4 text-left mb-3'>
            {/*<p style={{ color: "blue", fontSize: "16px" }} className='mb-2  font_size_13px text-right '>. jpg | . pdf file</p>*/}
            <ThemeProvider theme={CustomFontTheme}>

              <TextField size="small" label="Category Image ( . png Only )" id="outlined-start-adornment" inputProps={{ accept: "image/png" }} InputLabelProps={{ shrink: true }} variant="outlined" type="text"
                className="form-control" name='catIng' value={catImage}
                InputProps={{
                  endAdornment: (
                    <IconButton component="label">
                      <FileUploadOutlinedIcon />
                      <input style={{ display: "none" }} type="file" accept="image/png,image/jpeg,image/jpg" hidden onChange={(event) => onUploadDispImg(event)} name="catImgHiddenImg" />
                    </IconButton>

                  ),
                }} />
            </ThemeProvider>
          </div>

          <div className="col-4 text-left">
            <div className="form-group"  >
              <label className="form-group mr-3 pt-2" > Status</label>
              <FormControl><RadioGroup row name='status' value={status}
                onChange={(e) => { setStatus(Number(e.target.value)) }} >
                <FormControlLabel value="1" label="Activate" control={<Radio size="small" color="success" />} />
                <FormControlLabel value="0" label="Deactive" control={<Radio size="small" color="error" />} />
              </RadioGroup>
              </FormControl>
            </div>
          </div>

        </div>

        <ToastContainer />
      </div>

      <div className="card-footer col-12 text-center">
        <Button style={{ color: "green" }} className="mr-4" onClick={() => createNewSubCategory()} variant="text" startIcon={<ArrowUpwardRoundedIcon />}>
          Submit
        </Button>
        <Button style={{ color: "red" }} className="ml-4" onClick={() => navigate('../sub_categories')} variant="text" startIcon={<ClearOutlinedIcon />}>
          Cancel
        </Button>
      </div>
    </div>

  );
}

export default SubCategoryDetails;
